import rtl from '@/styles/rtl.module.scss';

export const IconTrendDown = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={rtl.dirDependent}
  >
    <path
      d="M22.75 17.9999V12M22.75 17.9999H16.75M22.75 17.9999L15.75 11C15.2048 10.4547 14.9321 10.1821 14.638 10.0363C14.0785 9.75905 13.4215 9.75905 12.862 10.0363C12.5679 10.1821 12.2952 10.4547 11.75 11V11C11.2047 11.5452 10.9321 11.8179 10.638 11.9636C10.0784 12.2409 9.4215 12.2409 8.86195 11.9636C8.56785 11.8179 8.29522 11.5452 7.74995 11L2.75 6"
      stroke="currentcolor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
